import cn from 'classnames';
import React, {FC, useEffect} from 'react';
import {useSelector} from 'react-redux';

import Button from '../../../../../components/Button/Button';
import {getReconnectDeviceGuideData} from '../../../../../config/dataConfig/dataConfig';
import * as reconnectGuideTypes from '../../../../../consts/app/reconnectGuideTypes';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import useDeviceName from '../../../../../hooks/useDeviceName';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import {showReconnectDeviceGuideModalAction} from '../../../../../state/ducks/modal';
import {makeSelectIotDeviceFullData} from '../../../../../state/selectors/consumer';
import {dispatch} from '../../../../../state/store';
import styles from './ReconnectNotification.module.scss';

interface IProps {
    onClick: () => void;
    hideNotification: () => void;
}

const ReconnectNotification: FC<IProps> = (props) => {
    const {onClick, hideNotification} = props;
    const iotProduct = useSelector(makeSelectIotDeviceFullData());
    const {device} = iotProduct || {};
    const {type} = device || {};
    const name = useDeviceName();

    useEffect(() => {
        if (!name) {
            hideNotification();
        }
    }, [name]);

    const reconnectDeviceGuideData = getReconnectDeviceGuideData(type);
    const localizedStrings = getLocalizedStrings();
    const notificationText = localizedStrings.formatString(
        localizedStrings[localizationKeys.DEVICE_LOST_CONNECTION_NOTIFICATION_PART_1],
        name
    );

    const onButtonClick = () => {
        onClick();
        dispatch(showReconnectDeviceGuideModalAction({guideType: reconnectGuideTypes.REGULAR}));
    };

    return (
        <>
            {notificationText}
            {reconnectDeviceGuideData && (
                <Button className={cn(styles.NotificationText, 'ica--txt-regular')} onClick={onButtonClick}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: localizedStrings[localizationKeys.DEVICE_LOST_CONNECTION_NOTIFICATION_PART_2],
                        }}
                    />
                </Button>
            )}
        </>
    );
};

export default ReconnectNotification;
